import { render, staticRenderFns } from "./Quadrangle.vue?vue&type=template&id=a1b927d8&scoped=true&"
import script from "./Quadrangle.vue?vue&type=script&lang=js&"
export * from "./Quadrangle.vue?vue&type=script&lang=js&"
import style0 from "./Quadrangle.vue?vue&type=style&index=0&id=a1b927d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b927d8",
  null
  
)

export default component.exports